module.exports = __webpack_public_path__ + "static/media/aragon39.5507dc6e.jpg";